import type {
  HoverProductAction,
  HoverProductPayload,
  HoverProductState,
} from '../types/HoverProduct';

const types = {
  SET_HOVER_PRODUCT: 'SET_HOVER_PRODUCT',
} as const;

const actions = {
  setHoverProduct: (
    product: HoverProductState['product']
  ): HoverProductAction<HoverProductPayload> => ({
    type: types.SET_HOVER_PRODUCT,
    payload: { product },
  }),
};

const initial_state: HoverProductState = {
  product: null,
};

/**
 * This needs to be separate store for performance reasons as mouse over changes data a lot
 * multiple repaints are avoided when this is connected to minimal amount of components!
 * reducer which updates the order state in data store
 * @param {*} state
 * @param {*} action
 */
function reducer(
  state: HoverProductState = initial_state,
  action: HoverProductAction
): HoverProductState {
  switch (action.type) {
    case types.SET_HOVER_PRODUCT: {
      const payload = action.payload as HoverProductPayload;
      return {
        ...state,
        product: payload.product,
      };
    }

    default: {
      return state;
    }
  }
}

export { types as actionTypes, actions as default, reducer };
